var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPaymentCheckbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13075_4540",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13075_4540)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.92667 11.1648L7.53242 9.79136C7.41704 9.67598 7.29285 9.61695 7.15983 9.61428C7.02682 9.6116 6.89995 9.67063 6.77923 9.79136C6.65851 9.91209 6.59815 10.0411 6.59815 10.1784C6.59815 10.3156 6.65851 10.4446 6.77923 10.5654L8.46192 12.2481C8.59867 12.3848 8.75358 12.4532 8.92667 12.4532C9.09974 12.4532 9.25465 12.3848 9.3914 12.2481L13.2151 8.42434C13.3305 8.30897 13.3895 8.1813 13.3922 8.04134C13.3949 7.90139 13.3358 7.77105 13.2151 7.65032C13.0944 7.5296 12.9689 7.46924 12.8385 7.46924C12.7082 7.46924 12.5827 7.5296 12.4619 7.65032L8.92667 11.1648ZM10.0066 17.5846C8.96719 17.5846 7.98661 17.3872 7.06483 16.9925C6.14304 16.5978 5.33622 16.0547 4.64438 15.3631C3.95251 14.6716 3.40913 13.8651 3.01423 12.9438C2.61933 12.0224 2.42188 11.0421 2.42188 10.0027C2.42188 8.9494 2.61924 7.96534 3.01396 7.05051C3.40868 6.13566 3.95181 5.33232 4.64333 4.64047C5.33488 3.94861 6.14133 3.40523 7.06269 3.01032C7.98404 2.61542 8.9644 2.41797 10.0038 2.41797C11.0571 2.41797 12.0411 2.61533 12.956 3.01005C13.8708 3.40477 14.6742 3.9479 15.366 4.63943C16.0579 5.33097 16.6012 6.13395 16.9961 7.04836C17.391 7.96277 17.5885 8.94661 17.5885 9.99989C17.5885 11.0393 17.3911 12.0199 16.9964 12.9416C16.6017 13.8634 16.0586 14.6702 15.367 15.3621C14.6755 16.054 13.8725 16.5973 12.9581 16.9922C12.0437 17.3871 11.0599 17.5846 10.0066 17.5846Z",
    fill: "#DBDBDB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPaymentCheckbox);
export default __webpack_public_path__ + "static/media/ic-payment-checkbox.3e8dc6ce7031e3119b8112d55a6e1d79.svg";
export { ForwardRef as ReactComponent };